import m from 'mithril'

class Search {
    constructor() {}
    static fetch() {
        return m.request({
            method: 'GET',
            url: `${window.BASE_URL}/RentHouse/Get/searchItem`
        })
    }
    static fetchMap() {
        return m.request({
            method: 'GET',
            url: `${window.BASE_URL}/RentHouse/Get/searchItem`
        })
    }
    static fetchMrt() {
        return m.request({
            method: 'GET',
            url: `${window.BASE_URL}/RentHouse/Get/searchItem`
        })
    }
    static fetchList() {
        return m.request({
            method: 'GET',
            url: `${window.BASE_URL}/RentHouse/Get/searchItem`
        })
    }
}

export default Search